<ng-container *transloco="let t; read: 'partials.file_list'">
  <ng-container *ngIf="ac">
    <div class="dashboard-block" *ngIf="ac.hasFiles(auth.getUserType())">
      <div>
        <label for="date">{{ t('files') }}</label>
        <span id="date">
          <ng-container *ngFor="let file of ac.files">
            <p *ngIf="file.hasRight(auth.getUserType())" class="filename">
              <fa-icon class="p-mr-2" [icon]="file.icon"></fa-icon> <a (click)="downloadFile(file)" (keyup.enter)="downloadFile(file)" role="link" tabindex="0">{{ file.public_name }}</a>
            </p>
          </ng-container>
        </span>
      </div>
    </div>
  </ng-container>
</ng-container>
